// extracted by mini-css-extract-plugin
export var arrows = "_88-6";
export var decrementer = "_88-a";
export var disabled = "_88-4";
export var error = "_88-1";
export var hiddenText = "_88-b";
export var incrementer = "_88-9";
export var input = "_88-8";
export var inputWrapper = "_88-0";
export var leadingIcon = "_88-c";
export var readonly = "_88-3";
export var regular = "_88-7";
export var small = "_88-5";
export var warning = "_88-2";